export default __webpack_public_path__ + "static/media/hefkraan_mast.83e076f0.svg";